<template>
  <div class="message-notification-dropdown-wrapper">
    <!-- Trigger: NotificationDropdown / ProfileDropdown ile aynı header-widget-icon -->
    <a v-if="!isChatDisabled" class="header-widget-icon" href="javascript:void(0)">
      <i :style="iconStyle" class="uil-envelope-alt"></i>
      <span v-if="itemCount > 0"
            :class="['message-notification-badge', { 'message-notification-badge-large': itemCount > 99 }]">
        {{ itemCount }}
      </span>
    </a>

    <!-- Dropdown: NotificationDropdown ile aynı sınıflar ve uk-dropdown -->
    <div v-if="!isChatDisabled"
         ref="messageRefs"
         class="dropdown-notifications"
         uk-dropdown="pos: top-right; mode: click; animation: uk-animation-slide-bottom-small">
      <div class="dropdown-notifications-headline">
        <h4>{{ headerTitle || $t("home.Messages") }}</h4>
        <a v-if="showSettings" href="#" @click.prevent>
          <i class="icon-feather-settings" uk-tooltip="title: Mesaj Ayarları ; pos: left"></i>
        </a>
      </div>

      <div class="dropdown-notifications-content" data-simplebar>
        <ul>
          <li v-for="(item, index) in messageItems" :key="index">
            <a href="#" @click.prevent="handleMessageClick(item)">
              <span class="notification-avatar">
                <UserProfileAvatar :name="getMessageUserName(item)"
                                   :photo="getMessageUserPhoto(item)"
                                   class="message-notification-avatar"
                />
              </span>
              <span class="notification-text notification-msg-text">
                <strong class="d-block">{{ getMessageUserName(item) }}</strong>
                <p class="mb-0">{{ getMessageText(item) }}</p>
                <span class="time-ago d-block">{{ formatMessageDate(item) }}</span>
              </span>
            </a>
          </li>
        </ul>
      </div>

      <div class="dropdown-notifications-footer">
        <a href="javascript:void(0)" @click="handleSeeAllClick">
          {{ $t("home.see_all") }}
          <i class="icon-line-awesome-long-arrow-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";

export default {
  name: "MessageNotificationDropdown",
  components: {
    UserProfileAvatar
  },
  props: {
    isChatDisabled: {
      type: Boolean,
      default: false
    },
    itemCount: {
      type: Number,
      default: 0
    },
    messageItems: {
      type: Array,
      default: () => []
    },
    headerTitle: {
      type: String,
      default: null
    },
    showSettings: {
      type: Boolean,
      default: false
    },
    iconStyle: {
      type: String,
      default: ""
    },
    formatDateFunction: {
      type: Function,
      default: null
    }
  },
  methods: {
    /** Header route watcher tarafından dropdown'ı kapatmak için çağrılır - silinmemeli dikkat edilmeli */
    hide() {
      if (this.$refs.messageRefs) {
        UIkit.dropdown(this.$refs.messageRefs).hide(0);
      }
    },
    handleMessageClick(item) {
      this.hide();
      this.$emit('message-click', item);
    },
    handleSeeAllClick() {
      this.hide();
      this.$emit('see-all-click');
    },
    getMessageUserName(item) {
      return item.fullname || item.user?.fullname || "";
    },
    getMessageUserPhoto(item) {
      return item.user?.photo_link || item.photo_link || null;
    },
    getMessageText(item) {
      return item.message || "";
    },
    formatMessageDate(item) {
      if (this.formatDateFunction) {
        return this.formatDateFunction(item.date || item.created_at);
      }
      return "";
    }
  }
};
</script>

<style scoped>
.message-notification-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.message-notification-dropdown-wrapper .header-widget-icon {
  position: relative;
}

/* Sadece mesaj badge rengi (diğer stiller global .dropdown-notifications'tan gelir) */
.message-notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  color: #fff;
  background-color: #ec5252;
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 10;
}

.message-notification-badge-large {
  width: 30px;
  height: 30px;
  min-width: 30px;
  padding: 0;
}

/* İçerik yüksekliği: item kadar min, üst sınır max-height (global height: 315px override) */
.message-notification-dropdown-wrapper .dropdown-notifications-content {
  height: auto !important;
  min-height: 0;
  max-height: 400px;
  overflow-y: auto;
}

/* Mesaj satırı: metin kart içinde kalsın, alta insin (wrap) */
.dropdown-notifications-content .notification-msg-text {
  min-width: 0;
}

.message-notification-avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  font-size: 13px;
}
.dropdown-notifications-content .notification-msg-text strong {
  font-size: 13.7px;
  color: #343767;
}

.dropdown-notifications-content .notification-msg-text p {
  font-size: 13px;
  line-height: 1.4;
  color: #666;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

/* Mobil: NotificationDropdown / ProfileDropdown ile aynı konum */
@media (max-width: 640px) {
  .message-notification-dropdown-wrapper .dropdown-notifications {
    position: fixed !important;
    top: 56px !important;
    right: 8px !important;
    left: auto !important;
    width: calc(100vw - 16px) !important;
    max-width: 300px !important;
  }

  .message-notification-dropdown-wrapper .dropdown-notifications:before {
    display: none;
  }
}
</style>
